import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import { Api } from '@/common/api'


import './common/directives/select'
import './common/directives/datepicker'
import './common/directives/canaccess'

import "intro.js/introjs.css"
import "intro.js/themes/introjs-modern.css"

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: { id: "UA-154964766-1" },
    appName: 'Shopping CNA',
    pageTrackerScreenviewEnabled: true
}, router);

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueMask from 'di-vue-mask'
Vue.use(VueMask);

import money from 'v-money'
Vue.use(money)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import VueSession from 'vue-session'
Vue.use(VueSession)

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//import 'sweetalert2/dist/sweetalert2.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/bootstrap-material-design.css'
import './assets/css/style.css'

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue();

new Vue({
    router,
    render: h => h(App),
    mounted() {
        

        this.$eventHub.$on('show-notification', (data) => {

            var isMobile = IsMobile();

            let _config = {
                position: 'top',
                toast: isMobile,
                type: data.type,
                title: data.title,
                html: data.text,
                timer: 5000,
                showConfirmButton: false,
            }

            if (data.type == "error") {
                _config.timer = null;
                _config.showCancelButton = true;
                _config.cancelButtonText = "Fechar";
            }

            if (data.modal) {
                _config.position = 'center';
                _config.toast = false;
                _config.showConfirmButton = true;
                _config.showCancelButton = false;
                _config.timer = null;
                _config.allowOutsideClick = false;
                _config.allowEscapeKey = false;
                _config.allowEnterKey = false;
            }

            function IsMobile() {
                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)
                ) {
                    return false;
                }
                else {
                    return true;
                }
            }

            this.$swal(_config);
        })
    },
    beforeDestroy() {
        
        this.$eventHub.$off('show-notification');
    },
}).$mount('#app')
